<template>
  <div class="index">
    <nav-header></nav-header>
    <!-- banner -->
    <div class="banner">
      <img src="/imgs/b1.jpg" alt="" />
    </div>




    <div class="container">

      <!-- 关于我们 -->
      <div class="m-us">
        <!-- 标题 -->
        <div class="us-title">
          <h3>关于我们</h3>
          <p>以用户为中心 以人才为根本 努力实现你我共赢</p>
        </div>

        <!-- 文本 -->
        <div class="us-con">
          <div class="us-l">
            <h4>北京安吉迈医疗科技有限公司</h4>
            <p>
              经营范围包括一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；信息技术咨询服务；企业管理咨询；市场营销策划；广告设计、代理；广告制作；广告发布；健康咨询服务（不含诊疗服务）；食品销售（仅销售预包装食品）；特殊医学用途配方食品销售；第一类医疗器械销售；第二类医疗器械销售；个人卫生用品销售；卫生用品和一次性使用医疗用品销售；互联网销售（除销售需要许可的商品）；电子产品销售。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）（不得从事国家和本市产业政策禁止和限制类项目的经营活动。）
            </p>
            <a href="/#/info">查看详情</a>
          </div>
          <div class="us-r"></div>
        </div>

      </div>


      <!-- 标题 -->
      <div class="m-title">
        <div class="title-user">
          <div class="blink"></div>
          <h2>Industry information</h2>
          <div class="blink"></div>
        </div>
        <h4>行业资讯</h4>
      </div>
      <!-- 内容列表 -->
      <div class="m-list">
        <!-- 循环项 -->
        <div class="list-item" v-for="(item, index) in this.data" :key="index" @click="gopay(item.id)">
          <!-- 左侧图片 -->
          <div class="item-img">
            <img :src="item.img" alt="" />
          </div>
          <!-- 右侧信息 -->
          <div class="item-info">
            <!-- 标题 -->
            <div class="item-title">{{ item.title }}</div>
            <!-- 发布时间 -->
            <div class="item-time">{{ item.pay }}</div>
            <!-- 简介 -->
            <div class="item-jj">
              {{ item.jj }}
            </div>
            <!-- <div class="item-time">发布时间：{{ item.time }}</div> -->
          </div>
        </div>
      </div>
    </div>
    <modal title="请选择支付方式" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <img style="width:234px;" src="/imgs/pay2.png" />
        <p>扫码付款：2元</p>
      </template>
    </modal>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import Modal from "../components/Modal.vue";
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
export default {
  name: "index",
  components: {
    Modal,
    NavFooter,
    NavHeader,
  },
  data() {
    return {
      data: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "北京安吉迈医疗科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/info.json").then((res) => {
        const data = res.data;
        this.data = data.splice(0, 5);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      alert("付款2元后可预览~");
      this.showModal = true;
      // if (this.state == 0) {
      //   // this.$router.push("/pay");
      //   this.showModal = true;
      // }
      // // 未登录
      // if (this.state !== 0) {
      //   alert("请登录付费3元后可浏览！！！~");
      //   this.$router.push({ path: "/login", query: { k: 1 } });
      //   return;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.index {
  margin-top: 80px;

  .banner {
    width: 100%;
    height: 500px;

    // background-color: pink;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .container {

    // 关于我们
    .m-us {
      width: 100%;
      height: 600px;
      // background-color: pink;
      margin: 35px 0;

      .us-title {
        width: 100%;
        text-align: center;

        h3 {
          font-size: 24px;
          font-weight: bold;
        }

        p {
          font-size: 14px;
          color: #888;
          margin-top: 10px;
        }
      }

      .us-con {
        width: 100%;
        height: 530px;
        margin: 15px 0;
        background-image: url('/imgs/us.jpg');
        display: flex;
        align-items: center;

        .us-l {
          width: 652px;
          height: 463px;
          background: red;
          padding: 3% 4%;
          box-sizing: border-box;

          h4 {
            font-size: 30px;
            color: #fff;
            margin: 30px 0;
          }

          p {
            font-size: 16px;
            color: rgba(255, 255, 255, .8);
            width: 100%;
            height: auto;
            // max-height: 150px;
            overflow: hidden;
            line-height: 30px;
            text-align: justify;
            word-break: break-all;
            margin: 0;
            padding: 0;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
          }

          a {
            width: 130px;
            height: 38px;
            line-height: 38px;
            border: 1px solid #fff;
            text-align: center;
            margin-top: 40px;
            display: block;
            color: #fff;
          }
        }
      }
    }

    // 标题
    .m-title {
      width: 100%;
      text-align: center;
      margin-top: 60px;

      // 上层
      .title-user {
        display: flex;
        align-items: center;
        margin: 20px auto;
        justify-content: center;
        margin-bottom: 5px;

        h2 {
          font-size: 24px;
          margin: 0 15px;
        }

        .blink {
          width: 80px;
          height: 3px;
          background-color: #666;
        }
      }

      h4 {
        font-size: 18px;
      }
    }

    // 内容列表
    .m-list {
      width: 100%;
      padding: 20px 0;
      box-sizing: border-box;

      // 循环项
      .list-item {
        width: 100%;
        height: 300px;
        border-bottom: 1px solid #cfcfcf;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:hover {
          box-shadow: 0px 0px 6px #9e9b9b;
        }

        // 左侧图片
        .item-img {
          width: 35%;
          height: 100%;
          // background-color: #c60023;
          text-align: center;

          img {
            width: 290px;
            height: 190px;
            margin-top: 56px;
          }
        }

        // 右侧信息
        .item-info {
          width: 65%;

          // 标题
          .item-title {
            font-size: 21px;
          }

          // 发布时间
          .item-time {
            font-size: 16px;
            color: #666;
            margin: 15px auto;
          }

          // 简介
          .item-jj {
            font-size: 14px;
            line-height: 35px;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
